module.exports = __webpack_public_path__ + "static/media/TAOD.dfef323a.jpg";